function initMainProduct(root) {
  const productId = root?.dataset?.productId;
  if (!productId) return;
  const section = root.closest('.shopify-section--main-product') || root;

  try {
    let recentlyViewedProducts = JSON.parse(localStorage.getItem('theme:recently-viewed-products') || '[]');
    const id = Number(productId);
    recentlyViewedProducts = recentlyViewedProducts.filter((item) => item !== id);
    recentlyViewedProducts.unshift(id);
    localStorage.setItem('theme:recently-viewed-products', JSON.stringify(recentlyViewedProducts));
  } catch (e) {}

  try {
    const firstMedia = section.querySelector('.product-gallery__media:first-child');
    if (firstMedia) {
      firstMedia.style.position = 'relative';
    }
  } catch (e) {}
}

window.onTryOnBuynowCallback = function onTryOnBuynowCallback(sku) {
  console.log('VTO Buy Now clicked for SKU:', sku);
};

function initTidioPdpPositioning() {
  if (window.innerWidth > 699) return;

  function onTidioChatApiReady() {
    const tidioContainer = document.getElementById('tidio-chat');
    if (!tidioContainer) return;
    if (window.__tidioPdpPositioningInit) return;
    window.__tidioPdpPositioningInit = true;

    const computedStyle = window.getComputedStyle(tidioContainer);
    const tidioOriginalBottom = computedStyle.bottom || '6px';

    const stickyAddToCart = document.querySelector('.product-sticky-add-to-cart');
    const customSticky = document.querySelector('.custom-sticky');
    let updateTimeout = null;
    let lastAppliedBottom = null;
    let tidioPdpRevealed = false;

    function applyTidioBottomCore(forceApply) {
      if (window.innerWidth > 699) return;
      const el = document.getElementById('tidio-chat');
      if (!el) return;

      let maxHeight = 0;

      if (stickyAddToCart?.classList.contains('is-visible')) {
        maxHeight = Math.max(maxHeight, stickyAddToCart.offsetHeight || 0);
      }

      if (customSticky) {
        const style = getComputedStyle(customSticky);
        if (parseFloat(style.opacity) > 0 && style.pointerEvents !== 'none') {
          const rect = customSticky.getBoundingClientRect();
          maxHeight = Math.max(maxHeight, Math.max(0, window.innerHeight - rect.top));
        }
      }

      const bottomValue = maxHeight > 0 ? `${maxHeight + 6}px` : tidioOriginalBottom;

      if (!forceApply && lastAppliedBottom === bottomValue) return;
      lastAppliedBottom = bottomValue;

      if (window.tidioChatApi && typeof window.tidioChatApi.adjustStyles === 'function') {
        try {
          window.tidioChatApi.adjustStyles(
            `@media only screen and (max-width: 699px) { #tidio-chat { bottom: ${bottomValue} !important; } }`
          );
        } catch (e) {}
      }

      el.style.setProperty('bottom', bottomValue, 'important');
    }

    function revealTidioPdpChat() {
      if (tidioPdpRevealed) return;
      const el = document.getElementById('tidio-chat');
      if (!el) return;
      tidioPdpRevealed = true;
      applyTidioBottomCore(true);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          el.classList.add('tidio-pdp-position-ready');
        });
      });
    }

    function updateTidioPosition() {
      if (window.innerWidth > 699) return;
      clearTimeout(updateTimeout);
      updateTimeout = setTimeout(() => {
        applyTidioBottomCore(false);
      }, 50);
    }

    function onStickyClassChange() {
      updateTidioPosition();
      if (stickyAddToCart?.classList.contains('is-visible')) {
        setTimeout(revealTidioPdpChat, 80);
      }
    }

    if (stickyAddToCart) {
      new MutationObserver(onStickyClassChange).observe(stickyAddToCart, {
        attributes: true,
        attributeFilter: ['class']
      });
      if (stickyAddToCart.classList.contains('is-visible')) {
        setTimeout(revealTidioPdpChat, 80);
      }
    }

    window.updateTidioForStickies = updateTidioPosition;
    window.revealTidioPdpChat = revealTidioPdpChat;

    updateTidioPosition();
    setTimeout(revealTidioPdpChat, 1200);
    setTimeout(revealTidioPdpChat, 3500);
  }

  if (window.tidioChatApi) {
    if (typeof window.tidioChatApi.on === 'function') {
      window.tidioChatApi.on('ready', onTidioChatApiReady);
    }
    setTimeout(onTidioChatApiReady, 100);
  } else {
    document.addEventListener('tidioChat-ready', onTidioChatApiReady);
    let attempts = 0;
    const check = setInterval(() => {
      if (document.getElementById('tidio-chat') || window.tidioChatApi) {
        clearInterval(check);
        onTidioChatApiReady();
      } else if (++attempts > 30) {
        clearInterval(check);
      }
    }, 100);
  }
}

function initMainProductPage() {
  const productRoot = document.querySelector('.shopify-section--main-product [data-product-id]');
  if (productRoot) initMainProduct(productRoot);
  initTidioPdpPositioning();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMainProductPage);
} else {
  initMainProductPage();
}
